import React, { useState } from 'react';
import { FcSimCardChip } from "react-icons/fc";
import americanExpress from "../Layout/cardsIcon/americaExpress.png";
import dinersClub from "../Layout/cardsIcon/dinersClub.png";
import discover from "../Layout/cardsIcon/discover.png";
import jcb from "../Layout/cardsIcon/jcb.png";
import masterCard from "../Layout/cardsIcon/masterCard.png";
import unionPay from "../Layout/cardsIcon/unionPay.png";
import visa from "../Layout/cardsIcon/visa.png";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["creditCardType"]?.[key] || fallback;

const CreditCardType = (props) => {
    __setElakayInfoSource(props.infoSource);
    const [isHovered, setIsHovered] = useState(false);

    let fullName = String(props.name).toLocaleUpperCase();
    let lastDigi = props.last4;
    let exp_month = props.exp_month;
    let exp_year = String(props.exp_year).slice(-2);
    let brand = props.brand;

    // Styles CSS Premium avec animations
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes cardEntrance {
    from {
        opacity: 0;
        transform: translateY(30px) rotateX(20deg) scale(0.9);
    }
    to {
        opacity: 1;
        transform: translateY(0) rotateX(0deg) scale(1);
    }
}

@keyframes shimmerCard {
    0% {
        background-position: -200% center;
    }
    100% {
        background-position: 200% center;
    }
}

@keyframes chipPulse {
    0%, 100% {
        transform: scale(1);
        filter: brightness(1);
    }
    50% {
        transform: scale(1.05);
        filter: brightness(1.2);
    }
}

@keyframes digitGlow {
    0%, 100% {
        text-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
    }
    50% {
        text-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
    }
}

@keyframes hologramEffect {
    0%, 100% {
        opacity: 0.3;
    }
    50% {
        opacity: 0.6;
    }
}

/* ===== CARD CONTAINER ===== */
.credit-card-premium {
    perspective: 1000px;
    animation: cardEntrance 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) both;
    margin: 10px;
}

/* ===== CARD BASE ===== */
.card-premium {
    position: relative;
    width: 340px;
    height: 215px;
    border-radius: 18px;
    padding: 24px;
    color: white;
    transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-style: preserve-3d;
    box-shadow: 
        0 20px 60px rgba(0, 0, 0, 0.4),
        0 0 0 1px rgba(255, 255, 255, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
    overflow: hidden;
    cursor: pointer;
}

.card-premium:hover {
    transform: translateY(-10px) rotateX(5deg) rotateY(-5deg) scale(1.02);
    box-shadow: 
        0 30px 80px rgba(0, 0, 0, 0.5),
        0 0 0 1px rgba(255, 255, 255, 0.2),
        0 0 40px rgba(255, 255, 255, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

/* ===== HOLOGRAM OVERLAY ===== */
.card-premium::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.1) 25%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.1) 75%,
        rgba(255, 255, 255, 0) 100%
    );
    background-size: 200% 200%;
    animation: shimmerCard 3s linear infinite;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.card-premium:hover::before {
    opacity: 1;
}

/* ===== SHINE EFFECT ===== */
.card-premium::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
        circle at center,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 60%
    );
    animation: hologramEffect 4s ease-in-out infinite;
    pointer-events: none;
}

/* ===== CHIP PREMIUM ===== */
.chip-premium {
    position: absolute;
    top: 20px;
    left: 24px;
    z-index: 2;
    animation: chipPulse 2s ease-in-out infinite;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
    transition: all 0.3s ease;
}

.card-premium:hover .chip-premium {
    transform: scale(1.1) rotate(5deg);
}

/* ===== BRAND LOGO ===== */
.brand-logo-premium {
    position: absolute;
    z-index: 2;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4));
}

.card-premium:hover .brand-logo-premium {
    transform: scale(1.1) translateY(-3px);
    filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.5));
}

.brand-logo-premium img {
    display: block;
}

/* ===== CARD NUMBER ===== */
.card-number-premium {
    position: absolute;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 10px;
}

.digit-group-premium {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 2px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
}

.card-premium:hover .digit-group-premium {
    animation: digitGlow 1.5s ease-in-out infinite;
}

.last-digits-premium {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 3px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

/* ===== CARDHOLDER NAME ===== */
.cardholder-name-premium {
    position: absolute;
    bottom: 20px;
    left: 24px;
    z-index: 2;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
}

.card-premium:hover .cardholder-name-premium {
    transform: translateX(3px);
    text-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);
}

/* ===== EXPIRATION ===== */
.expiration-premium {
    position: absolute;
    bottom: 18px;
    right: 24px;
    z-index: 2;
    text-align: center;
    transition: all 0.3s ease;
}

.expiration-label {
    font-size: 9px;
    font-weight: 600;
    opacity: 0.8;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.expiration-date {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-top: 2px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.card-premium:hover .expiration-premium {
    transform: scale(1.05);
}

/* ===== CARD BACKGROUNDS ===== */

/* Visa */
.card-visa {
    background: linear-gradient(135deg, #1434A4 0%, #4169E1 50%, #5B9BD5 100%);
}

.card-visa:hover {
    background: linear-gradient(135deg, #0F2980 0%, #2E5BB8 50%, #4A8DC9 100%);
}

/* Mastercard */
.card-mastercard {
    background: radial-gradient(ellipse at right bottom, #EEB1BF 5%, #d42dab 25%, #4d1d63 50%, #030243 100%);
}

.card-mastercard:hover {
    background: radial-gradient(ellipse at right bottom, #FFC1CF 5%, #E43DBC 25%, #5D2D73 50%, #041253 100%);
}

/* Amex */
.card-amex {
    background: radial-gradient(circle at top left, #ff66b3 0%, #cc0066 50%, #660033 100%);
}

.card-amex:hover {
    background: radial-gradient(circle at top left, #ff77c4 0%, #dd1177 50%, #770044 100%);
}

/* Discover */
.card-discover {
    background: radial-gradient(ellipse at right bottom, #ff6666 5%, #ff4444 25%, #dd2255 50%, #990033 100%);
}

.card-discover:hover {
    background: radial-gradient(ellipse at right bottom, #ff7777 5%, #ff5555 25%, #ee3366 50%, #aa0044 100%);
}

/* Diners */
.card-diners {
    background: radial-gradient(ellipse at right bottom, #0088cc 10%, #0099dd 30%, #00aaee 70%, #00bbff 100%);
}

.card-diners:hover {
    background: radial-gradient(ellipse at right bottom, #0099dd 10%, #00aaee 30%, #00bbff 70%, #00ccff 100%);
}

/* JCB */
.card-jcb {
    background: radial-gradient(ellipse at right bottom, #5555ff 5%, #3333dd 25%, #2222bb 60%, #000099 100%);
}

.card-jcb:hover {
    background: radial-gradient(ellipse at right bottom, #6666ff 5%, #4444ee 25%, #3333cc 60%, #1111aa 100%);
}

/* UnionPay */
.card-unionpay {
    background: linear-gradient(135deg, #E31837 0%, #C8102E 50%, #9E1030 100%);
}

.card-unionpay:hover {
    background: linear-gradient(135deg, #F32847 0%, #D8203E 50%, #AE2040 100%);
}

/* ===== MAGNETIC STRIPE ===== */
.magnetic-stripe {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    height: 45px;
    background: linear-gradient(180deg, 
        rgba(0, 0, 0, 0.6) 0%, 
        rgba(0, 0, 0, 0.8) 50%, 
        rgba(0, 0, 0, 0.6) 100%
    );
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.card-premium:hover .magnetic-stripe {
    opacity: 0.3;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
    .card-premium {
        width: 300px;
        height: 190px;
        padding: 20px;
    }

    .chip-premium {
        top: 16px;
        left: 20px;
    }

    .card-number-premium {
        left: 20px;
    }

    .digit-group-premium {
        font-size: 16px;
    }

    .last-digits-premium {
        font-size: 18px;
    }

    .cardholder-name-premium {
        bottom: 16px;
        left: 20px;
        font-size: 14px;
    }

    .expiration-premium {
        bottom: 14px;
        right: 20px;
    }
}

/* ===== REDUCED MOTION ===== */
@media (prefers-reduced-motion: reduce) {
    .credit-card-premium,
    .card-premium,
    .chip-premium,
    .brand-logo-premium,
    .digit-group-premium,
    .cardholder-name-premium,
    .expiration-premium {
        animation: none !important;
        transition: none !important;
    }

    .card-premium:hover {
        transform: none;
    }
}
`;

    const cardForrm = (cardClass, brandLogo, logoPosition) => (
        <div className="credit-card-premium">
            <style>{premiumStyles}</style>
            <div 
                className={`card-premium ${cardClass}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Magnetic Stripe */}
                <div className="magnetic-stripe"></div>

                {/* Chip */}
                <div className="chip-premium">
                    <FcSimCardChip size={50} />
                </div>

                {/* Brand Logo */}
                <div className="brand-logo-premium" style={logoPosition}>
                    {brandLogo}
                </div>

                {/* Card Number */}
                <div className="card-number-premium">
                    <span className="digit-group-premium">****</span>
                    <span className="digit-group-premium">****</span>
                    <span className="digit-group-premium">****</span>
                    <span className="last-digits-premium">{lastDigi}</span>
                </div>

                {/* Cardholder Name */}
                <div className="cardholder-name-premium">
                    {fullName}
                </div>

                {/* Expiration */}
                <div className="expiration-premium">
                    <div className="expiration-label">{__elakayText("t001", "VALID THRU")}</div>
                    <div className="expiration-date">{exp_month}/{exp_year}</div>
                </div>
            </div>
        </div>
    );

    const selCard = (brand) => {
        let cardClass;
        let brandLogo;
        let logoPosition;

        switch (brand) {
            case 'visa':
                cardClass = 'card-visa';
                logoPosition = { top: '15px', right: '24px' };
                brandLogo = <img src={visa} alt={__elakayText("t002", "Visa")} style={{ width: '85px' }} />;
                break;

            case 'mastercard':
                cardClass = 'card-mastercard';
                logoPosition = { top: '15px', right: '24px' };
                brandLogo = <img src={masterCard} alt={__elakayText("t003", "Mastercard")} style={{ width: '85px' }} />;
                break;

            case 'amex':
                cardClass = 'card-amex';
                logoPosition = { top: '10px', right: '24px' };
                brandLogo = <img src={americanExpress} alt={__elakayText("t004", "Amex")} style={{ width: '90px' }} />;
                break;

            case 'discover':
                cardClass = 'card-discover';
                logoPosition = { top: '25px', right: '24px' };
                brandLogo = <img src={discover} alt={__elakayText("t005", "Discover")} style={{ width: '130px' }} />;
                break;

            case 'diners':
                cardClass = 'card-diners';
                logoPosition = { top: '15px', right: '24px' };
                brandLogo = <img src={dinersClub} alt={__elakayText("t006", "Diners Club")} style={{ width: '85px' }} />;
                break;

            case 'jcb':
                cardClass = 'card-jcb';
                logoPosition = { top: '12px', right: '24px' };
                brandLogo = <img src={jcb} alt="JCB" style={{ width: '85px' }} />;
                break;

            case 'unionpay':
                cardClass = 'card-unionpay';
                logoPosition = { top: '15px', right: '24px' };
                brandLogo = <img src={unionPay} alt={__elakayText("t008", "UnionPay")} style={{ width: '85px' }} />;
                break;

            default:
                cardClass = 'card-visa';
                logoPosition = { top: '15px', right: '24px' };
                brandLogo = <img src={visa} alt={__elakayText("t009", "Card")} style={{ width: '85px' }} />;
        }

        return cardForrm(cardClass, brandLogo, logoPosition);
    };

    return (
        <>
            {selCard(brand)}
        </>
    );
};

export default CreditCardType;